import React from "react";
import { Redirect, Router, Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { authRoutes, pageRoutes, paymentPageRoutes, mainRoutes } from "./index";

import LayoutIndex from "../layouts";
import PageLayout from "../layouts/PageLayout";
import MainLayout from "../layouts/MainLayout";
import AuthLayout from "../layouts/AuthLayout";
import PaymentLayout from "../layouts/PaymentLayout";

import ScrollToTop from "../components/ScrollToTop";

import { createBrowserHistory } from "history";
import KakaoAuth from "../components/auth/KakaoAuth";
const history = createBrowserHistory();

const Routes = () => {
  const mapRoutes = (Layout, routes) =>
    routes.map(({ path, component: Component }, index) => (
      <Route
        key={index}
        path={path}
        exact
        render={(props) => (
          <LayoutIndex>
            <Layout>
              <Component {...props} />
            </Layout>
          </LayoutIndex>
        )}
      />
    ));

  return (
    <Router history={history}>
      <ScrollToTop>
        {/* <Route
          path="/auth/kakao/callback"
          render={(props) => (
            <LayoutIndex>
              <Layout>
                <KakaoAuth {...props} />
              </Layout>
            </LayoutIndex>
          )}
        /> */}
        <Switch>
          {mapRoutes(AuthLayout, authRoutes)}
          {mapRoutes(PageLayout, pageRoutes)}
          {mapRoutes(PaymentLayout, paymentPageRoutes)}
          {mapRoutes(MainLayout, mainRoutes)}
          ));
          <Redirect to="/" />
        </Switch>
      </ScrollToTop>
    </Router>
  );
};

const mapStateToProps = (state) => ({
  auth: state.api_auth,
});

export default connect(mapStateToProps)(Routes);
